import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { useGenGridCol } from "../../../../../utils/HelperComp";
import { usePermission, useTranslation } from "../../../../../hooks";
import OpIconButton from "../../../../../components/OpIconButton";
import { OpCreateDoc } from "../../../../../assets/icons";
import { translatePrefix, translateKeyObj as TK, Pkey } from "../../config";
import { useReduxContext, setCreateRequest } from "../../reduxContext";
import { useAppSelector } from "../../../../../reducer/hooks";
import { selectProfile } from "../../../../../reducer/profileSlice";

const useTableColumns = () => {
  const { hasPermission } = usePermission();

  const { t } = useTranslation(translatePrefix);

  const [_, dispatch] = useReduxContext();
  const { merchantId } = useAppSelector(selectProfile);

  const renderOperationButton = (params: GridRenderCellParams) => {
    const onClick = () => {
      dispatch(setCreateRequest(params.row.rawData));
    };
    const fromMerchantId = params?.row?.rawData?.from_merchant_id;

    const isDisableCreateRequest =
      String(fromMerchantId) !== String(merchantId) ||
      params?.row?.rawData?.status !== 1;

    return (
      <OpIconButton
        title={t(TK.createRequest)}
        url={OpCreateDoc}
        size="1.9rem"
        onClick={onClick}
        isDisabled={isDisableCreateRequest}
      />
    );
  };

  const columns: GridColDef[] = [
    useGenGridCol(TK.operation, t(TK.operation), {
      minWidth: 70,
      renderCell: renderOperationButton,
    }),
    useGenGridCol(TK.merchantFrom, t(TK.merchantFrom), { minWidth: 150 }),
    useGenGridCol(TK.chainNameFrom, t(TK.chainNameFrom), { minWidth: 150 }),
    useGenGridCol(TK.currencyFrom, t(TK.currencyFrom), { minWidth: 100 }),
    useGenGridCol(TK.merchantTo, t(TK.merchantTo), { minWidth: 150 }),
    useGenGridCol(TK.chainNameTo, t(TK.chainNameTo), { minWidth: 150 }),
    useGenGridCol(TK.currencyTo, t(TK.currencyTo), { minWidth: 150 }),
    useGenGridCol(TK.merchantLp, t(TK.merchantLp), { minWidth: 150 }),
    useGenGridCol(TK.liquidityProvider, t(TK.liquidityProvider), {
      minWidth: 150,
    }),
    useGenGridCol(TK.creationTime, t(TK.creationTime), { minWidth: 150 }),
    useGenGridCol(TK.lastModifiedTime, t(TK.lastModifiedTime), {
      minWidth: 150,
    }),
  ].filter(({ field }) => {
    if (field === TK.operation) {
      return hasPermission(Pkey.TabMerchant.CreateRequest);
    }
    return true;
  });

  return { columns };
};

export default useTableColumns;
